export const NumericalOnlyStringGuard = (value: unknown): string | null => {
	const numericOnlyRegex = new RegExp(/^-?\d+$/);

	if (typeof value === 'number') return value.toString();
	if (typeof value === 'string' && numericOnlyRegex.test(value)) return value;
	if (typeof value === 'string' && value.length === 0) return value;

	return null;
};

export const PostalCodeStringGuard = (value: unknown): string | null => {
	const numericOnlyRegex = new RegExp(/^-?\d+$/);

	if (typeof value === 'string') {
		if (value.length <= 2 && numericOnlyRegex.test(value)) return value;
		if (value.length === 3 && numericOnlyRegex.test(value))
			return `${value.slice(0, 2)}-${value.slice(2)}`;
		if (
			value.length >= 3 &&
			value.length <= 6 &&
			value.charAt(2) === '-' &&
			numericOnlyRegex.test(value.slice(0, 2)) &&
			(value.length > 3 ? numericOnlyRegex.test(value.slice(3)) : true)
		) {
			return value;
		}
	}
	if (typeof value === 'string' && value.length === 0) return value;

	return null;
};

export const DateStringGuard = (value: unknown): string | null => {
	const numericOnlyRegex = new RegExp(/^-?\d+$/);

	if (typeof value === 'string') {
		if (value.length <= 4 && numericOnlyRegex.test(value)) return value;
		if (value.length === 5 && numericOnlyRegex.test(value))
			return `${value.slice(0, 4)}-${value.slice(4)}`;
		if (
			value.length >= 5 &&
			value.length <= 7 &&
			value.charAt(4) === '-' &&
			(value.length > 5 ? numericOnlyRegex.test(value.slice(5)) : true)
		)
			return value;
		if (value.length === 8 && numericOnlyRegex.test(value.slice(7))) {
			return `${value.slice(0, 7)}-${value.slice(7)}`;
		}
		if (
			value.length >= 8 &&
			value.length <= 10 &&
			value.charAt(7) === '-' &&
			(value.length > 8 ? numericOnlyRegex.test(value.slice(8)) : true)
		)
			return value;
	}
	if (typeof value === 'string' && value.length === 0) return value;

	return null;
};
